<template>
  <div class="form-input">

    <div class="text text--small" v-html="content.formInputText"></div>

    <div class="form">
      <form class="form__form" method="POST" v-bind:action="endpoint" ref="form">

        <div class="form__row">
          <div class="row">
            <div class="col-md-6">
              <dropdown name="gender"
                        :label="content.formLabels.gender"
                        :select-label="content.formLabels.pleaseSelect"
                        :options="content.formLabels.genderOptions"></dropdown>

            </div>
          </div>
        </div>

        <div class="form__row">
          <div class="row">
            <div class="col-md-6">
              <form-field :label="content.formLabels.name"
                          name="firstname"
                          type="text"
                          validation="required"></form-field>
            </div>
            <div class="col-md-6">
              <form-field :label="content.formLabels.lastname"
                          name="name"
                          type="text"
                          validation="required"></form-field>
            </div>
          </div>
        </div>

        <div class="form__row">
          <div class="row">
            <div class="col-md-12">
              <form-field :label="content.formLabels.email"
                          name="email"
                          type="email"
                          validation="email|required"></form-field>
            </div>
          </div>
        </div>

        <div class="form__row">
          <div class="row">
            <div class="col-12">
              <div class="form__row form__row--mt-0">
                <checkbox name="terms"
                          :label="content.terms"
                          :required="true"></checkbox>
              </div>
            </div>

            <div class="col-12">
              <div class="form__row form__row--small">
                <checkbox name="newsletter"
                          :label="content.newsletter"
                          :required="false"></checkbox>
              </div>
            </div>
            <div class="col-12">
              <div class="form__row form__row--small">
                <div class="checkbox__label checkbox__label--legal" v-html="content.legalData"></div>
                <button @click.prevent="openOverlay(content.itemsBig['item-2']['content'])"
                        class="checkbox__label checkbox__label--terms" v-html="content.termsData"></button>
              </div>
            </div>

            <div class="col-12 d-flex align-items-end justify-content-end">
              <div class="form__submit">
                <button class="button button--secondary" :class="{'button--loading': loading}" type="submit" :disabled="loading"
                        @click.prevent="submitForm">{{ content.continueLabel}}</button>
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>

    <div class="form-input__error-modal" v-show="showErrormessage">
      <p v-if="isInvalid" class="form-field__label form-field__label--error" v-html="invalidEmailMessage"></p>
      <p v-if="isUsed" class="form-field__label form-field__label--error" v-html="usedEmailMessage"></p>
      <p v-if="hasError" class="form-field__label form-field__label--error" v-html="errorMessage"></p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      submitError: false,
      loading: false,
      success: false
    }
  },
  computed: {
    ...mapGetters([
      'formParticipationState',
      'content',
      'formSubmittedState',
      'language'
    ]),
    endpoint() {
      return  process.env.VUE_APP_API_URL + 'form/validate'
    },
    showErrormessage() {
      return this.formParticipationState === 'invalid' || this.formParticipationState === 'used' || this.formParticipationState === 'error'
    },
    isInvalid() {
      return this.formParticipationState === 'invalid'
    },
    isUsed() {
      return this.formParticipationState === 'used'
    },
    hasError() {
      return this.formParticipationState === 'error'
    },
    invalidEmailMessage() {
      return this.content.formParticipationErrors.emailInvalid
    },
    usedEmailMessage() {
      return this.content.formParticipationErrors.emailUsed
    },
    errorMessage() {
      return this.content.formParticipationErrors.general
    }
  },
  watch: {
    submitError: function(error) {
      if (error) {
        setTimeout(() => {
          this.submitError = false;
        }, 3000);
      }
    }
  },
  methods: {
    ...mapActions([
      'checkFormParticipation',
      'resetAll',
      'openOverlay',
      'closeOverlay'
    ]),
    submitForm: async function() {
      this.loading = true;
      let validations = [];

      for (let i = 0; i < this.$children.length; i++) {
        if (typeof this.$children[i].validate === 'function') {
          validations.push(this.$children[i].validate());
        }
      }

      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('register');

      Promise.all(validations).then(results => {
        let valid = true;
        results.forEach(result => {
          if (!result) {
            valid = false;
          }
        });

        if (valid) {
          let postData = {}
          postData['g-recaptcha-response'] = token

          for (let i = 0; i < this.$refs.form.elements.length; i++) {
            if (this.$refs.form.elements[i].name.length > 0) {
              if (this.$refs.form.elements[i].type === 'checkbox') {
                postData[this.$refs.form.elements[i].name] = this.$refs.form.elements[i].checked
              } else {
                postData[this.$refs.form.elements[i].name] = this.$refs.form.elements[i].value
              }
            }
          }
          postData.language = this.language

          this.checkFormParticipation({
            data: postData, onSuccess: this.onSuccess, onError: this.onError
          }).catch(() => {
            this.onError();
          });
        } else {
          this.loading = false
        }
      });
    },
    onSuccess() {
      this.loading = false;
      this.success = true;
    },
    onError() {
      this.submitError = true;
      this.loading = false;
    }
  }
}
</script>

<style lang="scss">
@import '../assets/sass/variables';

.form-input {
  position: relative;
  z-index: 100;

  width: 100%;
  height: auto;

  padding: 25px;

  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08), 0 0 50px 0 rgba(0, 0, 0, 0.05);

  @media (min-width: 768px) {
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);
  }

  @media (min-width: 1204px) {
    width: 120%;

    padding: 25px;
  }

  @media (min-width: 1440px) {
    width: 100%;

    padding: 35px;
  }

  @media (min-width: 1680px) {
    width: 90%;

    padding: 45px;
  }

  &__error-modal {
    color: #d0021b;
  }

  .checkbox {

    &__label  {
      font-size: 14px;

      &--legal,
      &--terms {
        font-size: 13px;
      }

      &--terms {
        color: #c6a55a;

        margin-top: 5px;

        padding-left: 0;
        background: none;
        border: none;

        transition: opacity .2s ease-in;

        -webkit-appearance: none;

        &:hover {
          opacity: .5;
        }
      }
    }
  }

  .form {

    &__row  {
      margin-top: 25px;

      &--mt-0 {
        margin-top: 0;
      }
    }

    &__submit {
      margin-top: 25px;
    }
  }
}

</style>